import React from "react";
import {Flex} from "reflexbox";
import Typography from "@mui/material/Typography";
import * as route from "../helpers/routes";
import * as type from "./questionTypes"
import {tippingMidway, teamNameInput} from './questionContentUniversal'

//location images tidal basin
import mlkPic from '../../images/tidalBasin/locations/mlkPic.jpg'
import fdrPic from '../../images/tidalBasin/locations/fdrPic.jpg'
import pagodaPic from '../../images/tidalBasin/locations/pagodaPic.jpg'
import bridgePic from '../../images/tidalBasin/locations/bridgePic.jpg'
import masonPic from '../../images/tidalBasin/locations/masonPic.jpg'
import jeffPic from '../../images/tidalBasin/locations/jeffersonPic.jpg'

//mlk images
import mlkBlocks from "../../images/tidalBasin/questionPics/mlkBlocks.jpg"
import childBlocks from "../../images/tidalBasin/questionPics/childBlocks.jpg"
import mlkCounted from "../../images/tidalBasin/questionPics/mlkCounted.jpg"
import moralArcOfUniverse from "../../images/tidalBasin/questionPics/moralArcOfUniverse.jpg"
import mountainOfDespair from "../../images/tidalBasin/questionPics/mountainOfDespair.jpg"
import sculptorSignature from "../../images/tidalBasin/questionPics/sculptorSignature.jpg"
import drumMajor from "../../images/tidalBasin/questionPics/drumMajor.jpg"
import mlkLooking from "../../images/tidalBasin/questionPics/mlkLooking.jpg"
// FDR images
import brailleClue from "../../images/tidalBasin/questionPics/brailleClue.png"
import brailleAnswer from "../../images/tidalBasin/questionPics/brailleAnswer.png"
import menInFoodLine from "../../images/tidalBasin/questionPics/menInFoodLine.jpg"
import rocksWithIhateWar from "../../images/tidalBasin/questionPics/rocksWithIhateWar.jpg"
import trashCanRock from "../../images/tidalBasin/questionPics/trashCanRock.jpg"
import oneThird from "../../images/tidalBasin/questionPics/oneThird.jpg"
import depressionMan from "../../images/tidalBasin/questionPics/depressionMan.jpg"
import manListeningQuestion from "../../images/tidalBasin/questionPics/manListeningQuestion.jpg"
import manListeningAnswer from "../../images/tidalBasin/questionPics/manListeningAnswer.jpg"
import hats from "../../images/tidalBasin/questionPics/hats.jpeg"
import wheelchairParts from "../../images/tidalBasin/questionPics/wheelchairParts.jpg"
import fdrAnimalsPic from "../../images/tidalBasin/questionPics/animalsAtFDRpic.jpg"
import elanorRooseveltPic from "../../images/tidalBasin/questionPics/elanorRooseveltPic.jpg"


//bridge & mason images
import bridgeAges from "../../images/tidalBasin/questionPics/bridgeAges.jpg"
import fisherGrotesque from "../../images/tidalBasin/questionPics/fisherGrotesque.jpg"
import masonIntroPic from "../../images/tidalBasin/questionPics/masonIntroPic.jpg"
import masonsAuthors from "../../images/tidalBasin/questionPics/masonsAuthors.jpg"

// jefferson images
import beneathJeffersonSign from "../../images/tidalBasin/questionPics/beneathJeffersonSign.jpg"
import jeffersonCornerstoneImage from "../../images/tidalBasin/questionPics/jeffersonCornerstone.jpg"
import jeffersonPediment from "../../images/tidalBasin/questionPics/jeffersonPediment.jpg"
import rEvansPic from "../../images/tidalBasin/questionPics/rEvans.jpg"
import {Link} from "react-router-dom";
import DCMapOverlap from "./DCMapOverlap";
import {ToMap} from "../helpers/routes";

const mlk = {
  name: 'Martin Luther King Jr Memorial',
  img: mlkPic,
};

const fdr = {
  name: 'Franklin Delano Roosevelt Memorial',
  img: fdrPic,
};

const pagoda = {
  name: 'Japanese Pagoda',
  img: pagodaPic,
};

const ohioBridge = {
  name: 'Ohio Drive Tidal Basin Bridge',
  img: bridgePic,
};

const mason = {
  name: 'George Mason Memorial',
  img: masonPic,
};

const tj = {
  name: 'Thomas Jefferson Memorial',
  img: jeffPic,
};

const getToMLK = {
  location: mlk,
  type: type.newLocation,
  image1: null,
  content1: "Re-arrange the three letters that come after ‘J’ in the alphabet and you will be guided to this place.",
  captionContent: "Tap 'I'm here' when you are at the entrance to this memorial.",
  answer: {
    image1: mlk.img,
    content1: 'You made it!'
  }
};

const mountainName = {
  displayName: "Mountain Name",
  location: mlk,
  type: type.freeTextQuestion,
  image1: null,
  content1: null,
  boldContent: 'What mountain does the stone of MLK’s statue come from?',
  hint: 'Read the quote on the pillar of rock around the MLK statue',
  answer: {
    answer: new RegExp("(despair)"),
    answerInfo: {
      image1: mountainOfDespair,
      image1Caption: "Mountain of Despair.",
      content1: 'On the left face of MLK\'s statue, you can read a quote that says "Out of the mountain of despair, a stone of hope"',
    },
    //image1: ,
    content1: ' This is a reference to MLK\'s "I have a dream" speech, when he said “With this faith, we will be able to hew out of the mountain of despair a stone of hope."',
  },
};


const sculptorOrigin = {
  displayName: "Sculptor Nationality",
  location: mlk,
  type: type.freeTextQuestion,
  image1: null,
  content1: null,
  boldContent: 'Where is the MLK memorial sculptor from?',
  hint: "Look around where MLK's left foot would be and you will find the sculptor's signature. His signature is indicative of the country that he is from.",
  answer: {
    answer: new RegExp("(china|asia|chinese)"),
    answerInfo: {
      image1: sculptorSignature,
      //image1Caption: "",
      content1: 'To the bottom right of MLK’s feet, you can see the signature of Lei Yixin in Chinese characters.',
    },
    //image1: sculptorSignature,
    content1: "In addition to the artist being chinese, so is the stone. The sculptor, Lei Yixin, and his team only came to the US briefly for the finishing touches. ",
    content2: "The decision to hire Lei came with some criticism from human rights activists as Lei has also sculpted Mao Zedong, the founding Chinese communist leader. Some speculate that Lei was chosen because the Chinese Government promised to make a $25 million donation to the project.",

  },
};

const missingQuote = {
  displayName: "Missing MLK quote",
  location: mlk,
  type: type.freeTextQuestion,
  image1: null,
  content1: "Ignoring the sculptor's signature we just looked at,",
  boldContent: "What’s something that the left side (South East side) of the Stone of Hope has that the right side (North West side) does not have?",
  hint: "Don't over think it. What does one side have that the other doesn't?",
  answer: {
    answer: new RegExp("(quote|engraving|quotation|phrase|words|letters|script|stone of hope|inscription|carv|writing)"),
    answerInfo: {
      //image1: ,
      //image1Caption: "",
      content1: 'The left side of the pillar has a quote while the right side is bare.',
    },
    image1: null,
    content1: "Interestingly, there used to be a quote on the pillar's ride side, however it was removed because it was paraphrased and critics insisted it did not capture King's original intention. ",
    image2: drumMajor,
    content2: 'The original MLK quote was "If you want to say that I was a drum major, say that I was a drum major for justice. Say that I was a drum major for peace. I was a drum major for righteousness. And all of the other shallow things will not matter."'
  },
};

const legoStone = {
  displayName: "# of Lego Rocks",
  location: mlk,
  type: type.freeTextQuestion,
  image1: childBlocks,
  content1: "Look closely at the side of the statue and you’ll notice that the 'stone of hope' is made up of several blocks glued together, like Legos or bricks on a building.",
  boldContent: 'How many blocks of stone make up MLK’s pillar of rock? Answers within 5 count',
  hint: "Most of the stones are only have the width of the statue (visible from the back). Count the blocks on one side of MLK's statue and multiply by two.",
  answer: {
    answer: new RegExp("(3[6-9]|4[1-6])"),
    answerInfo: {
      image1: mlkCounted,
      content1: "41 granite blocks make up the stone. The very front is made up of 7 stones, each the full width of the statue. Behind that, there are 17 stones, which cover only half the width of the statue (noticeable from the back). Together 17 x 2 + 7 = 41.",
    },
    image1: mlkBlocks,
    content1: 'The blocks were carved in China and brought to the US for assembly and final touches',
    content2: 'Here you can see workers getting ready to put the block with MLK\'s face into place.'
  },
};

const mlkCommonWord = {
  displayName: "Most common MLK word",
  location: mlk,
  type: type.freeTextQuestion,
  image1: null,
  content1: "Read MLK's powerful quotes in the dark granite that encircle the monument.",
  boldContent: 'What is the most common word that appears? Functional words like “to, of the, our, these” don’t count.',
  hint: 'It is one of the words that appears in: "True peace is not merely the absence of tension; it is the presence of justice."',
  answer: {
    answer: new RegExp("(^peace$)"),
    answerInfo: {
      //image1: ,
      //image1Caption: "",
      content1: 'Peace is used 5 times and is present in 4 of the quotes. It would have been 6 and 5 if the Drum Major quote had remained.',
    },
    image1: null,
    content1: 'Love is second most frequent, used 4 times and present in 4 quotes.'
  },
};

const arcOfMoralUniverse = {
  displayName: "Arc of moral universe",
  location: mlk,
  type: type.freeTextQuestion,
  image1: null,
  content1: null,
  boldContent: 'What direction does the arc of the moral universe bend towards?',
  hint: 'Read the quote in dark granite on the far left (closest to the FDR memorial)',
  answer: {
    answer: new RegExp("(justice)"),
    answerInfo: {
      image1: moralArcOfUniverse,
      //image1Caption: "",
      content1: 'On the far left on the wall of quotes, one of the quotes reads: "We shall overcome because the arc of the moral universe is long, but it bends toward justice."',
    },
    //image1: moralArcOfUniverse,
    //content1: '"We shall overcome because the arc of the moral universe is long, but it bends toward justice."',
  },

};

const mlkDone = {
  location: mlk,
  type: type.locationDone,
  image1: mlk.img,
  content1: 'That is all the questions for the ' + mlk.name + '. Nice work!',
};

const getToFDRv1 = {
  location: fdr,
  type: type.newLocation,
  image1: mlkLooking,
  content1: "MLK is looking towards your next destination. It is a memorial for a president that had four terms in office and is just a short walk away.",
  //hint: 'Just think about it',
  captionContent: "Tap 'I'm here' when you see the statue of a man in a wheelchair.",
  answer: {
    image1: fdr.img,
    content1: 'You made it! The FDR memorial is divided into five "rooms". You are in the prologue room and then there is one room for each of FDR\'s four terms in office. The start of each "room" is engraved into the ground.'
  },
};

const getToFDRv2 = {
  location: fdr,
  type: type.newLocation,
  image1: mlkLooking,
  content1: "Your next destination is a memorial for a president who's name is commonly abbreviated to three letter. Most presidents serve two terms... this one served four! The memorial has five 'rooms', one for each term in office, as well as a prologue room. We will go through the rooms in order, which means you'll have to walk past several rooms to the starting point.",
  //hint: 'Just think about it',
  captionContent: "Tap 'I'm here' when you see the statue of a man in a wheelchair.",
  answer: {
    image1: fdr.img,
    content1: 'You made it! You are in the prologue room. You\'ll stay in this space for the next series of questions. '
  },
};

const fdrOrganization = {
  displayName: "FDR Organization",
  location: fdr,
  type: type.informational,
  content1: "One of the questions towards the end of the FDR memorial will ask you what animals you've seen. Keep this question in mind as you walk through all the different rooms.",
};

const braille = {
  displayName: "Braille",
  location: fdr,
  type: type.freeTextQuestion,
  image1: brailleClue,
  content1: null,
  boldContent: null,
  hint: 'Look at the quote behind the FDR wheelchair statue and you\'ll see braille underneath a quote from Eleanor Roosevelt. Match up the symbols against the letters',
  answer: {
    answer: new RegExp("(honest)"),
    answerInfo: {
      image1: brailleAnswer,
      //image1Caption: "",
      content1: "The Braille spells H-O-N-E-S-T",
      content2: "You can use the Braille behind the FDR statue to map the letters to the symbols"
    },
    content1: 'Initially, the FDR memorial did not have the Prologue Room where you stand right now and the only representation of FDR was a statue that you will see later, where you cannot see that he sat in a wheelchair. Disability advocates successfully lobbied to have this prologue room added to his memorial so that visitors can see what FDR actually looked like - which was in his wheelchair because of Polio. ',
    content2: 'During his presidency, most Americans did not know that FDR was disabled. The press and FDR’s allies went through a lot of effort to hide his condition from the public because there was a stigma of thinking of disabled people as weak. '
  },
};

const wheelChair = {
  displayName: "FDR's wheelchair",
  location: fdr,
  type: type.freeTextQuestion,
  image1: null,
  content1: "FDR didn't have a regular wheelchair.",
  boldContent: 'Name one of the specific three items that his special chair was constructed out of:',
  hint: 'Take a look at the plaque on the back of the FDR statue, right above the ground',
  answer: {
    answer: new RegExp("(kitchen chair|tricycle|bicycle)"),
    answerInfo: {
      image1: wheelchairParts,
      //image1Caption: "",
      content1: "If you inspect the back of the FDR statue, you can find a plaque that describes the objects that create the wheelchair: A common kitchen chair, tricycle wheels, and bicycle wheels.",
    },
    //image1: ,
    content1: "Wheelchair technology has come a long way since FDR was president!",
  },
};

const hollowRocks = {
  displayName: "Hollow rocks",
  location: fdr,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'There are some blocks of rock that are hollow on the inside.',
  boldContent: 'What are they used for?',
  hint: 'If you had a used candy wrapper, where would you put it?',
  answer: {
    answer: new RegExp("(trash|garbage|rubbish|litter|waste|debris)"),
    answerInfo: {
      image1: trashCanRock,
      content1: "It's the trash cans.",
    },
    // image1: trashCanRock,
    // content1: "It's the trash cans.",
  },
};


const lastInLine = {
  displayName: "Last in line",
  location: fdr,
  type: type.freeTextQuestion,
  image1: menInFoodLine,
  content1: 'Proceed to the second room for FDR\'s second term in office, for which the Great Depression took center stage.  Note that the start of each "room" is denoted by an engraving in the stone on the ground.',
  boldContent: 'For the men standing in the food line, what makes the one in the back of the line different from the rest?',
  hint: '',
  answer: {
    answer: new RegExp("(hat)"),
    answerInfo: {
      //image1: ,
      //image1Caption: "",
      content1: "It is his hat - He's wearing a newsboy or flatcap hat whereas the others are wearing Trilby hats.  ",
    },
    image1: hats,
    content1: "Hat wearing back in the day was much more common that it is today. There are many theories for why it went out of fashion -- one is that the hat used to be necessary for work, which was typically outside and agricultural. However, as work shifted to inside factories and covered transportation was adopted, the hat became a fashion accessory and went out of favor. "
  },
};

const firstInLine = {
  displayName: "First in line",
  location: fdr,
  type: type.freeTextQuestion,
  image1: null,
  content1: null,
  boldContent: 'What makes the man that is first in line different from the rest?',
  hint: 'Look at where the others have their hands',
  answer: {
    answer: new RegExp("(hands|pocket|arms|cross|hug)"),
    answerInfo: {
      //image1: ,
      //image1Caption: "",
      content1: 'His hands are crossed while all the other men have their hands in their pockets. ',
    },
    //image1: null,
    //content1: '',
  },

};

const illHousedAndIllClad = {
  displayName: "Ill housed, clad, and nourished",
  location: fdr,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'According to FDR in his second term, ',
  boldContent: 'what fraction of the country was ill housed, ill clad and ill nourished?',
  hint: 'Read the quotes above the men standing in the food line',
  answer: {
    answer: new RegExp("(third|0.33|1/3)"),
    answerInfo: {
      image1: oneThird,
      content1: 'One third. In his second inaugural address, FDR said, "I see one-third of a nation ill-housed, ill-clad, ill-nourished." ',
      //image1: ,
      //image1Caption: "",
      //content1: "",
    },
    image1: depressionMan,
    content1: 'In the Great Depression, unemployment skyrocketed from 3% to 25%, many families lost all their savings when over 11,000 banks failed (this was before FDIC insurance, which was created as a response), and the stock market lost ~90% of its value. Recovering economically dominated FDR\'s first and second terms as President.',
  },
};
const firesideChat = {
  displayName: "Fireside chat",
  location: fdr,
  type: type.freeTextQuestion,
  image1: manListeningQuestion,
  content1: 'Find the statue pictured above. ',
  boldContent: 'What is the man doing?',
  hint: 'Look to the right of the men standing in the food line',
  answer: {
    answer: new RegExp("(radio|listening)"),
    answerInfo: {
      image1: manListeningAnswer,
      //image1Caption: "",
      content1: "The answer is listening to the radio.",
    },
    content1: 'TV was not broadly adopted until the 1950s. Thus, when FDR was President, he directly addressed the American people via radio. ',
    content2: 'FDR\'s broadcasts during the great depressions became famously known as "FDR\'s fireside chats". Many people felt like the president was speaking directly to them - no previous presidents had used radio the way FDR did.'
  },
};
const iHateWar = {
  displayName: "I hate war rock",
  location: fdr,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'Continue onwards to room three',
  boldContent: 'Amongst piles of broken rock, you’ll find something that FDR hates. What is it?',
  hint: 'Find the broken pile of rocks and look for engraved words on them.',
  answer: {
    answer: new RegExp("(war)"),
    answerInfo: {
      image1: rocksWithIhateWar,
      //image1Caption: "",
      content1: '"I hate war" is inscribed on two piles of rocks',
    },
    content1: '"I hate war" is an excerpt from FDR\'s speech about World War II. During the war, it is estimated that across the globe, 15 million soldiers and 45 million civilians were killed, of which over 400 thousand soldiers were American. ',
    content2: 'The World War II memorial is between the Lincoln and Washington memorials and is worth checking out!',
  },

};

const fdrAnimals = {
  displayName: "FDR Animals",
  location: fdr,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'Continue to room 4. Once you are here, think about all the rooms you\'ve been to.',
  boldContent: 'What three animals were you able to spot at this memorial?',
  hint: 'Look at the funeral relief in room four, the seal at the entrance to room one, and the pet next to FDR in room three.',
  answer: {
    answer: new RegExp("^(?=.*\\eagle\\b)(?=.*\\bhorse\\b)(?=.*\\bdog\\b).*$"),
    answerInfo: {
      image1: fdrAnimalsPic,
      content1: 'Horse, Eagle, and Dog',
      content2: "You'll find the horse on FDR's funeral frieze, the Eagle on the presidential seal, and the dog next to his statue in the third term"
    },
    // image1: fdrAnimalsPic,
    // content1: 'Horse, Eagle, and Dog',
  },
};

const eleanorRoosevelt = {
  displayName: "Eleanor Roosevelt",
  location: fdr,
  type: type.freeTextQuestion,
  image1: null,
  content1: null,
  boldContent: 'What other famous person has a statue at FDR\'s memorial?',
  hint: 'This statue is in the last room',
  answer: {
    answer: new RegExp("(eleanor|elanor|wife|first lady|ambassador)"),
    answerInfo: {
      image1: elanorRooseveltPic,
      content1: 'Eleanor Roosevelt',
    },
    // image1: elanorRooseveltPic,
    // content1: 'Eleanor Roosevelt',
  },

};

const fdrDone = {
  location: fdr,
  type: type.locationDone,
  image1: fdr.img,
  content1: 'That is all the questions for the ' + fdr.name + '. Nice work!',
};

const getToPagoda = {
  location: pagoda,
  type: type.newLocation,
  image1: null,
  content1: "The FDR memorial is made up of granite from South Dakota. Exit the FDR memorial and nearby you'll find some stone from Japan",
  //hint: 'Just think about it',
  captionContent: "Tap 'I'm here' when you see the thing.",
  answer: {
    image1: pagoda.img,
    content1: 'You made it!'
  },
};

const pagodaDone = {
  location: pagoda,
  type: type.locationDone,
  image1: pagoda.img,
  content1: 'That is all the questions for the ' + pagoda.name + '. Nice work!',
  content2: "The pagoda isn't the only thing the people of Japan gave to the Tidal Basin - the Cherry trees themselves were a gift from the Mayor of Tokyo in 1912. However, the first batch of 2,000 trees were burned rather than planted because of insects that came with the trees. Luckily, the second batch of trees has no such issues and many still survive today! ",
  //content3: "Lining the Potomac with Cherry trees was the brainchild of Eliza Scidmore and Helen Taft (President Taft's wife)."
};

const pagodaQuestion = {
  displayName: "Missing with pagoda",
  location: pagoda,
  type: type.freeTextQuestion,
  image1: null,
  content1: null,
  boldContent: 'What did the pagoda lack when it first arrived in the US?',
  hint: 'Read the informational placard next to the pagoda',
  answer: {
    answer: new RegExp("(instructions|directions|guide|manual)"),
    answerInfo: {
      //image1: ,
      //image1Caption: "",
      content1: 'Assembly instructions. The Library of Congress staff had to guess how to put it together!',
      content2: 'Find this answer on the informational sign by the Pagoda'
    },
    //image1: null,
    //content1: 'Assembly instructions. The Library of Congress staff had to guess how to put it together!',
  },

};

const getToOhioBridge = {
  location: ohioBridge,
  type: type.newLocation,
  image1: null,
  content1: "Your next destination is something that you can pass on top of or underneath but not within. Without me you’d need to swim or get in a boat!",
  //hint: 'Just think about it',
  captionContent: "Tap 'I'm here' when you're on it.",
  answer: {
    image1: ohioBridge.img,
    content1: 'You made it!'
  },
};

const fishSmile = {
  displayName: "Fish smile",
  location: ohioBridge,
  type: type.freeTextQuestion,
  image1: null,
  content1: null,
  boldContent: 'As you cross the bridge, you’ll see something fishy with a big smile. What kind of teeth does the fish have?',
  hint: 'Staying on the sidewalk, stand on the middle of the bridge and you will see a grotesque (i.e. a gargoyle but without the water spout)',
  answer: {
    answer: new RegExp("(human|people|person|man)"),
    answerInfo: {
      image1: fisherGrotesque,
      //image1Caption: "",
      content1: "Human teeth! ",
    },
    //image1: fisherGrotesque,
    content1: 'These bronze statues were commissioned and honor Jack Fisher - A National Park Service leader. ',
    content2: 'The NPS is the government agency that improves and maintains National Parks as well as the memorials around DC.'
  },

};

const bridgeAge = {
  displayName: "Bridge age",
  location: ohioBridge,
  type: type.freeTextQuestion,
  image1: null,
  content1: null,
  boldContent: 'When was the bridge built?',
  hint: 'The year the bridge was built is carved on each end',
  answer: {
    answer: new RegExp("(1908|1909)"),
    answerInfo: {
      //image1: ,
      //image1Caption: "",
      //content1: "",
      image1: bridgeAges,
      content1: '1908 or 1909. Interestingly, each side of the bridge has a different year.',
    },
    // image1: bridgeAges,
    // content1: '1908 or 1909. Interestingly, each side of the bridge has a different year.',
  },

};

const ohioBridgeDone = {
  location: ohioBridge,
  type: type.locationDone,
  image1: ohioBridge.img,
  content1: 'That is all the questions for the ' + ohioBridge.name + '. Nice work!',
};

const getToMason = {
  location: mason,
  type: type.newLocation,
  image1: null,
  content1: "My ancestors worked with stone, yet my memorial has less stone than the MLK, FDR, and Jefferson memorials. ",
  captionContent: "Tap 'I'm here' when you're at the memorial entrance.",
  //hint: 'Just think about it',
  answer: {
    image1: mason.img,
    content1: 'You made it!'
  },
};

const masonAuthorOf = {
  displayName: "Author of",
  location: mason,
  type: type.freeTextQuestion,
  image1: null,
  content1: null,
  boldContent: 'What was George Mason the author of?',
  hint: null,
  answer: {
    answer: new RegExp("(rights)"),
    answerInfo: {
      image1: masonIntroPic,
      content1: 'George Mason was the author of the First Bill of Rights as well as part author of the Declaration of Independence. ',
    },
    // image1: masonIntroPic,
    // content1: 'George Mason was the author of the First Bill of Rights as well as part author of the Declaration of Independence. ',
  },
};

const masonFavoriteAuthors = {
  displayName: "Mason's favorite authors",
  location: mason,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'George Mason was an author but also an avid reader. ',
  boldContent: 'What\'s the name of one of the authors that he respected?',
  hint: 'Look at the books closely near Mason.',
  answer: {
    answer: new RegExp("(lock|rous|cicer)"),
    answerInfo: {
      image1: masonsAuthors ,
      //image1Caption: "",
      content1: "Near Mason's left hand, you'll see a pile of books, whose spines identify authors Locke, Rousseau, and Cicero.",
    },
    //image1: masonsAuthors,
    content1: 'Locke, Rousseau, and Cicero are all moral and philosophical authors that influenced Mason.',
    content2: "For exmaple, Rousseau's 1762 book, \"Du Contrat Social\" (\"The Social Contract\"), argued against the idea that kings have the god given right to rule and instead argues it should be by the people."

  },
};

const numberButtons = {
  displayName: "Number of buttons",
  location: mason,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'In George Mason’s time, the number of buttons you wore was a sign of wealth.',
  boldContent: 'How many buttons can you count on Mason\'s statue?',
  hint: 'You may need to look at the back of the statue to get all the buttons.',
  answer: {
    answer: new RegExp("(30|31)"),
    answerInfo: {
      content1: 'Mason\'s statue has 30 visible buttons. 31 if you count the button on the hat.',
      content2: (<Flex style={{flexDirection: 'column'}}>
        <Typography>Coat pockets: 3 on each side, total 6</Typography>
        <Typography>Coat opening: 4</Typography>
        <Typography>Shirt buttons: 5</Typography>
        <Typography>Shirt pocket (left): 3</Typography>
        <Typography>Pant seam: 6 on right leg (top), 4 on left leg (bottom), total 10</Typography>
        <Typography>Back of coat: 2</Typography>
      </Flex>)
    },
    image1: null,
    content1: "The number of buttons you had on your coat used to be a status symbol, like wearing a designer brand can be today"
  },

};

const bulwarksOfLiberty = {
  displayName: "Number of buttons",
  location: mason,
  type: type.freeTextQuestion,
  image1: null,
  content1: null,
  boldContent: 'What is one of the “the greatest bulwarks of liberty, and can never be restrained by despotic governments.”?',
  hint: 'Look to the right of Mason and read the engraved quotes.',
  answer: {
    answer: new RegExp("(press)"),
    answerInfo: {
      //image1: ,
      //image1Caption: "",
      content1: "On one of the panels to the right of Mason, there is engraved quote that says 'Freedom of the Press is the greatest bulwarks of liberty'",
    },
    // image1: null,
    // content1: 'Freedom of the press',
  },

};

const masonDone = {
  location: mason,
  type: type.locationDone,
  image1: mason.img,
  content1: 'That is all the questions for the ' + mason.name + '. Nice work!',
};

const getToTJ = {
  location: tj,
  type: type.newLocation,
  image1: null,
  content1: "It won't cost you money to get in here but a nickel could help you find it!",
  //hint: 'Just think about it',
  captionContent: "Tap 'I'm here' when you're at the steps leading up to the memorial.",
  answer: {
    image1: tj.img,
    content1: ' It\'s the Jefferson Memorial!',
    content2: <Typography>You'll also notice <Link to={ToMap('mlkToJefferson')}>on the map</Link> that the Lincoln, MLK, and
      Jefferson memorials are all in a line. This is meant to symbolize the connection between the three leaders in
      their
      efforts for equality: from Thomas Jefferson writing in the 1700s that “all men are created equal”, to Lincoln
      issuing the emancipation proclamation in the 1800s, and to MLK advocating for equality and ending segregation in
      the
      1900s.</Typography>
  },
};

const tablePeople = {
  displayName: "People around Table",
  location: tj,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'Inside a triangle and around a table gather some people.',
  boldContent: 'How many people are there?',
  hint: 'Stand between the Jefferson Memorial and the Tidal Basin and look above the columns.',
  answer: {
    answer: new RegExp("(five|5)"),
    answerInfo: {
      image1: jeffersonPediment,
      //image1Caption: "",
      content1: 'There are five people within the pediment of the Jefferson memorial.',
    },
    //image1: jeffersonPediment,
    content1: 'The memorial pediment depicts the five people that worked on the Declaration of Independence.',
    content2: 'While Thomas Jefferson was the primary author of the Declaration of Independence, four other Continental Congress members were on the Declaration Committee and shaped what went into the document: John Adams, Roger Sherman, Robert Livingston, and Benjamin Franklin. '
  },
};

const rEvans = {
  displayName: "R Evans",
  location: tj,
  type: type.freeTextQuestion,
  image1: null,
  content1: "Someone else’s name that’s not Thomas Jefferson is sculpted into the statue.",
  boldContent: 'Whose name is it?',
  hint: 'Walk around the Thomas Jefferson statue in its entirety and look at the statue base, where the metal meets stone',
  answer: {
    answer: new RegExp("(evans)"),
    answerInfo: {
      image1: rEvansPic,
      //image1Caption: "",
      content1: "Right below Jerrson's feet, you can see 'R Evans'",
    },
    //image1: rEvansPic,
    content1: 'Rudulph Evans sculpted the Jefferson statue and signed his name, "R Evans".',
    content2: 'When the Jefferson Memorial was completed in 1943, it only had a painted plaster sculpture of Jefferson. This was because WWII was raging at the time and all metals went to the war effort. In 1947, Evans completed the metal statue that you see today. '
  },
};

const tjsOpinions = {
  displayName: "Jefferson's Opinions",
  location: tj,
  type: type.freeTextQuestion,
  image1: null,
  content1: "Thomas Jefferson had many opinions.",
  boldContent: 'How many “opinions” does he have on the walls of the memorial?',
  hint: 'Count how many times the word "opinion" is written in Jefferson\'s quotes. ',
  answer: {
    answer: new RegExp("(three|3)"),
    answerInfo: {
      //image1: ,
      //image1Caption: "",
      content1: 'The word "opinion" is written three times in Jefferson\'s quotes. '
    },
    image1: null,
    //content1: 'The word "opinion" is written three times in Jefferson\'s quotes. ',
  },

};

const beneathTJ = {
  displayName: "Beneath TJ",
  location: tj,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'When standing next to the Jefferson statue, you are actually standing on top of something.',
  boldContent: 'What lies beneath?',
  hint: 'Look around for an elevator or stairs that take you down. What is one of the the things the signs say is down there?',
  answer: {
    answer: new RegExp("(restroom|bathroom|toilet|shop|store|exhibit|museum)"),
    answerInfo: {
      image1: beneathJeffersonSign,
      //image1Caption: "",
      content1: "There are signs that indicate that below the memorial are restrooms, shops, and an exhibit are beneath the memorial.",
    },
    // image1: null,
    // content1: '',
  },

};

const jeffersonCornerstone = {
  displayName: "Jefferson Cornerstone",
  location: tj,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'This area of the National Mall was almost turned into a beach club before another president made an executive push to turn it into a memorial for Thomas Jefferson.',
  boldContent: 'Which president was it?',
  hint: 'This president laid a cornerstone that bears his name near the entrance to the memorial.',
  answer: {
    answer: new RegExp("(fdr|roosevelt)"),
    answerInfo: {
      image1: jeffersonCornerstoneImage,
      //image1Caption: "",
      content1: "At the top of the primary steps, you'll find a inscription that identifies FDR as the person to lay the cornerstone",
    },
    //image1: jeffersonCornerstoneImage,
    content1: 'FDR was a huge fan of Jefferson and was the driving force behind the memorial getting constructed. Since FDR travelled in a wheel-chair, the memorial was built to include an elevator. Accessible buildings were uncommon at the time.',
  },
};

const overlayDCMapsJefferson = {
  displayName: "Overlay of DC Maps",
  location: tj,
  type: type.informational,
  content1: <DCMapOverlap/>,
};

const jeffersonDone = {
  location: tj,
  type: type.locationDone,
  image1: tj.img,
  content1: 'That is all the questions for the ' + tj.name + '. Nice work!',
};

export const mlkToJeffersonContent = {
  getToMLK,
  mountainName,
  sculptorOrigin,
  missingQuote,
  legoStone,
  mlkCommonWord,
  arcOfMoralUniverse,
  mlkDone,

  getToFDRv1,
  fdrOrganization,
  braille,
  wheelChair,
  hollowRocks,
  lastInLine,
  firstInLine,
  illHousedAndIllClad,
  firesideChat,
  iHateWar,
  fdrAnimals,
  eleanorRoosevelt,
  fdrDone,

  getToPagoda,
  pagodaQuestion,
  pagodaDone,

  getToOhioBridge,
  fishSmile,
  bridgeAge,
  ohioBridgeDone,

  getToMason,
  masonAuthorOf,
  masonFavoriteAuthors,
  numberButtons,
  bulwarksOfLiberty,
  masonDone,

  tippingMidway,

  getToTJ,
  tablePeople,
  rEvans,
  beneathTJ,
  jeffersonCornerstone,
  overlayDCMapsJefferson,
  jeffersonDone,
};

export const jeffersonToMlkContent = {
   getToTJ,
   tablePeople,
   rEvans,
   tjsOpinions,
   beneathTJ,
   jeffersonCornerstone,
   overlayDCMapsJefferson,
   jeffersonDone,

   getToMason,
   masonAuthorOf,
   masonFavoriteAuthors,
   numberButtons,
   bulwarksOfLiberty,
   masonDone,

   getToOhioBridge,
   fishSmile,
   bridgeAge,
   ohioBridgeDone,

   getToFDRv2,
   fdrOrganization,
   braille,
   wheelChair,
   hollowRocks,
   lastInLine,
   firstInLine,
   illHousedAndIllClad,
   firesideChat,
   iHateWar,
   fdrAnimals,
   eleanorRoosevelt,
   fdrDone,

   tippingMidway,

   getToPagoda,
   pagodaQuestion,
   pagodaDone,

   getToMLK,
   mountainName,
   sculptorOrigin,
   missingQuote,
   legoStone,
   mlkCommonWord,
   arcOfMoralUniverse,
   mlkDone,

};